export const validation = {
  maxTitleChar: 15,
  maxParagraphChar: 500,
  paragraph: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}
